const events = new EventDelegator( [
{
  selector: '#js-app',
  eventType: 'click',
  events:
  {
    suggestion: ( e, d ) =>
    {
     open_section( d.suggestion );
    },

    welcome: ( e, d ) =>
    {
      welcome_btns( d.welcome );
      $('#top-bar__balance-btn, #header__social').css('visibility', 'visible');
    },

    dev: ( e, d ) =>
    {
      open_section( d.dev );
    },

    acceptCookie: ( e ) =>
    {
      $( e.target ).parent( '.cookie' ).remove();
    },

    tohub: () =>
    {
      open_section( 'hub' );
    },

    scrollto: ( e, d ) =>
    {
      e.preventDefault();
      ecommerce_scrollto( d.scrollto );
    },

    info: ( e, d ) =>
    {
      info_btn( e, d );
      showshare(false, false);
      displayCheckout(false);
    },

    backtosection: ( e, d ) =>
    {
      open_section( d.backtosection );
    },

    requestlocation: () =>
    {
      trackFriends();
    },

    closemapalert: () =>
    {
      cached_elements.remove_class( '#js-social-map-container', 'permission-denied' );
    },

    socialstatustab: ( e, d ) =>
    {
      manage_social_status_tabs( d.socialstatustab );
    },

  }
},
{
  selector: '#social-file-upload',
  eventType: 'change',
  events:
  {
    socialinput: ( e ) =>
    {
      handle_files( e.target.files );
    }
  }
},
{
  selector: '#js-app',
  eventType: 'dragenter',
  events:
  {
    app: ( e, d ) =>
    {
      e.preventDefault();
      e.stopPropagation();
    },
    socialdrag: ( e, d ) =>
    {
      e.preventDefault();
      e.stopPropagation();
      highlight_drop_area();

    }
  }
},
{
  selector: '#js-app',
  eventType: 'dragover',
  events:
  {
    app: ( e, d ) =>
    {
      e.preventDefault();
      e.stopPropagation()
    },
    socialdrag: ( e, d ) =>
    {
      e.preventDefault();
      e.stopPropagation();
      highlight_drop_area();
    }
  }
},
{
  selector: '#js-app',
  eventType: 'dragleave',
  events:
  {
    app: ( e, d ) =>
    {
      e.preventDefault();
      e.stopPropagation()
    },
    socialdrag: ( e, d ) =>
    {
      e.preventDefault();
      e.stopPropagation();
      unhighlight_drop_area( e );
    }
  }
},
{
  selector: '#js-app',
  eventType: 'drop',
  events:
  {
    app: ( e, d ) =>
    {
      e.preventDefault();
      e.stopPropagation()
    },
    socialdrag: ( e, d ) =>
    {
      e.preventDefault();
      e.stopPropagation();
      unhighlight_drop_area( e, true );
      handle_drop( e );
    }
  }
} ] );

window.addEventListener("beforeunload", function (e) {
  var confirmationMessage = "\o/";

  (e || window.event).returnValue = confirmationMessage; //Gecko + IE
  return confirmationMessage;                            //Webkit, Safari, Chrome
});